export class AlertMessageModel {
    title: string;
    message: string;
}
export interface IAlertDangerConfig {
    title: string;
    message: string;
 }
